import { useContext } from "react"
import { globalStoreContext } from "src/store/GlobalStore"
import useSWR from "swr"
import { fetchOwnRequestedTieups } from "../../models/tieup/fetchOwnRequestedTieups"

const useOwnTieups = () => {
  const {
    globalStore: {
      user: { clientState },
    },
  } = useContext(globalStoreContext)

  const { data } = useSWR(
    clientState === 2 ? `/v1/mypage/tieup` : null,
    async () => {
      return fetchOwnRequestedTieups().then((v) => v.items)
    },
    {
      // 自動更新OFF
      revalidateOnFocus: false,
    },
  )

  return {
    ownTieups: data,
  }
}

export { useOwnTieups }
